import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserSideBar from "./userSideBar";
import weatherBg from "./UserImage/weatherB.jpg";

const WeatherQuery = () => {
    const [city, setCity] = useState("");
    const [weather, setWeather] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
        const [username, setUsername] = useState("");
    
        useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const accessToken = params.get("token");
            const usernameParam = params.get("username");
    
            if (accessToken) {
                localStorage.setItem("access_token", accessToken);
                if (usernameParam) {
                    localStorage.setItem("username", usernameParam);
                    setUsername(usernameParam);
                }
                // Remove token from URL
                window.history.replaceState({}, document.title, "/user");
            } 
            // Else if we don't have a token stored, redirect to login
            else if (!localStorage.getItem("access_token")) {
                alert("You are not logged in. Redirecting to login...");
                navigate("/");
            } 
            // Otherwise, fetch the username from localStorage
            else {
                setUsername(localStorage.getItem("username") || "User");
            }
        }, [navigate]);
    // Fetch weather by city name
    const fetchWeather = async (query) => {
        if (!query) return;
        setLoading(true);
        setError("");
        try {
            const apiKey = "baf9582f7bc1a5a24af99865b847634a";
            const response = await fetch(
                `https://api.openweathermap.org/data/2.5/weather?q=${query}&units=metric&appid=${apiKey}`
            );

            if (!response.ok) throw new Error("City not found!");

            const data = await response.json();
            setWeather({
                name: data.name,
                temp: data.main.temp,
                description: data.weather[0].description,
                icon: data.weather[0].icon,
                humidity: data.main.humidity,
                wind: data.wind.speed,
            });
        } catch (err) {
            setError(err.message);
            setWeather(null);
        } finally {
            setLoading(false);
        }
    };

    // Fetch weather by geolocation
    const fetchWeatherByLocation = () => {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                setLoading(true);
                setError("");
                try {
                    const apiKey = "baf9582f7bc1a5a24af99865b847634a";
                    const response = await fetch(
                        `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=${apiKey}`
                    );

                    if (!response.ok) throw new Error("Unable to fetch location data!");

                    const data = await response.json();
                    setWeather({
                        name: data.name,
                        temp: data.main.temp,
                        description: data.weather[0].description,
                        icon: data.weather[0].icon,
                        humidity: data.main.humidity,
                        wind: data.wind.speed,
                    });
                } catch (err) {
                    setError(err.message);
                    setWeather(null);
                } finally {
                    setLoading(false);
                }
            },
            () => setError("Location access denied!")
        );
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-cover bg-center p-4"
            style={{ backgroundImage: `url(${weatherBg})` }} // Background Image
        >
            <UserSideBar />
            <div className="bg-white/80 dark:bg-gray-800/80 p-8 rounded-lg shadow-lg w-full max-w-md backdrop-blur-sm">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 text-center">
                    Weather Query
                </h1>

                {/* Input Field */}
                <input
                    type="text"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="Enter city name"
                    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
                />

                {/* Buttons in the same line */}
                <div className="flex justify-between">
                    {/* Get Weather Button */}
                    <button
                        onClick={() => fetchWeather(city)}
                        disabled={!city.trim()}
                        className={`px-4 py-2 rounded-md text-white ${
                            city.trim()
                                ? "bg-blue-500 hover:bg-blue-600"
                                : "bg-gray-400 cursor-not-allowed"
                        }`}
                    >
                        Get Weather
                    </button>

                    {/* Use My Location Button */}
                    <button
                        onClick={fetchWeatherByLocation}
                        className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
                    >
                        Use My Location
                    </button>
                </div>

                {/* Error Message */}
                {error && <p className="mt-4 text-red-500 text-center animate-pulse">{error}</p>}

                {/* Weather Details */}
                {loading && <p className="mt-4 text-center">Loading...</p>}
                {weather && (
                    <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-700 rounded-md shadow-md">
                        <h2 className="text-2xl font-bold text-gray-800 dark:text-white text-center">
                            {weather.name}
                        </h2>
                        <div className="flex items-center justify-center space-x-4 mt-2">
                            <img
                                src={`http://openweathermap.org/img/wn/${weather.icon}@2x.png`}
                                alt={weather.description}
                                className="w-18 h-18"
                            />
                            <div>
                                <p className="text-lg text-gray-600 dark:text-gray-300 capitalize">
                                    {weather.description}
                                </p>
                                <p className="text-gray-600 dark:text-gray-300">
                                    Temperature: {weather.temp}°C
                                </p>
                                <p className="text-gray-600 dark:text-gray-300">
                                    Humidity: {weather.humidity}%
                                </p>
                                <p className="text-gray-600 dark:text-gray-300">
                                    Wind Speed: {weather.wind} m/s
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            
        </div>
    );
};

export default WeatherQuery;
